import { Helmet } from "react-helmet-async";

const SITE_URL = "https://ozpropertyservicesco.com.au";

interface SeoProps {
  title: string;
  description: string;
  path: string;
}

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "MovingCompany"],
  "name": "Oz Property Services Co.",
  "url": SITE_URL,
  "telephone": "1800 556 654",
  "email": "hello@ozpropertyservicesco.com.au",
  "areaServed": [
    { "@type": "City", "name": "Melbourne" },
    { "@type": "City", "name": "Broadmeadows" },
    { "@type": "City", "name": "Craigieburn" },
    { "@type": "City", "name": "Glenroy" },
    { "@type": "City", "name": "Fawkner" },
    { "@type": "City", "name": "Coburg" },
    { "@type": "City", "name": "Pascoe Vale" },
    { "@type": "City", "name": "Tullamarine" },
    { "@type": "City", "name": "Mickleham" },
    { "@type": "City", "name": "Epping" }
  ],
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "AU",
    "addressRegion": "VIC",
    "addressLocality": "Melbourne"
  },
  "makesOffer": [
    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Interior Upgrades" } },
    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Outdoor Improvements" } },
    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Property Maintenance" } },
    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Security & Access" } },
    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Renovation Support" } },
    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Commercial Services" } }
  ],
  "sameAs": [
    "https://www.facebook.com/ozpropertyservicesco",
    "https://www.instagram.com/ozpropertyservicesco"
  ]
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Oz Property Services Co.",
  "url": SITE_URL
};

const Seo = ({ title, description, path }: SeoProps) => {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
    </Helmet>
  );
};

export default Seo;
